/**
 * BrandMark — the Bigxstar mark.
 *
 * The company mark, not the product name: it sits *beside* the "BigxBook"
 * wordmark rather than replacing it, so the till still says what it is while
 * carrying the house brand. Sourced from the Bigxstar site's own asset
 * (public/brand/bigxstar-mark.png) so the two never drift apart.
 *
 * Served from /public rather than imported, so swapping the file needs no
 * rebuild of the importing modules — useful when brand assets are refreshed
 * independently of a release.
 *
 * The four-colour mark reads on both the charcoal chrome and the light content
 * sheet without a variant, which is why there is only one file here. The
 * horizontal lockups (bigxstar-wordmark-light/dark.svg) sit alongside it for
 * anywhere the full logotype is wanted later.
 */
import { cn } from '@/utils/cn';

export function BrandMark({
  size = 24,
  className,
}: {
  /** Rendered edge length in px. The source is 500×500, so it stays sharp. */
  size?: number;
  className?: string;
}) {
  return (
    <img
      src="/brand/bigxstar-mark.png"
      // Decorative here: every placement pairs it with the word "BigxBook",
      // so announcing "Bigxstar" as well would just be noise for a screen
      // reader. Give it a real alt if it is ever used on its own.
      alt=""
      aria-hidden
      width={size}
      height={size}
      draggable={false}
      className={cn('shrink-0 select-none object-contain', className)}
      style={{ width: size, height: size }}
    />
  );
}
